import script from "./IssueFormModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssueFormModal.vue?vue&type=script&setup=true&lang=ts"

import "./IssueFormModal.vue?vue&type=style&index=0&id=e3f7f8c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3f7f8c2"]])

export default __exports__